import React, { useContext } from 'react'
import '../../../../../Portfolio_R/SummaryCharts/styles.scss'
import { useTranslation } from 'react-i18next';
import { useNumberFormatter } from '../../../../../../hooks/useNumberFormatter';
import usePortfolioName from '../../../../../../hooks/usePortfolioName';
import { TagFilterContext } from '../../../../../../context/TagFilterContext';
import HeaderExtended from '../../HeaderExtended';
import { LoanReportData } from '../typesExtendedReport';
import { useLoanMappedData } from './useLoanMappedData';
import CompositionLonCard from './components/CompositionLonCard';
import AmountsApprovedCard from './components/AmountsApprovedCard';
import WalletCompositionCard from './components/WalletCompositionCard';
import ProjectionsYearLon from './components/ProjectionsYearLon';
import PmrLonCard from './components/PmrLonCard';
import PendingCard from '../shared/PendingCard';
import TitlesAndValuesCard from '../shared/TitlesAndValuesCard';
import ReusableIcon from '../../shared/ReusableIcon';
import { ExpiredDisbursementsCard } from '../shared/ExpiredDisbursementsCard';

export const gradientColors = ['#0b396e', '#3975c8', '#00CFDD', '#f39f2e', '#ffd700'];
interface LoanProps {
    data: LoanReportData | null | undefined;
    creationDate: string | Date;
    regions: any;
    countries?: string;
    myPortfolio?: string;
    filtersApplied?: any;
}
const ExtendedReportLoan: React.FC<LoanProps> = ({ data, creationDate, regions, countries, myPortfolio, filtersApplied }) => {
    const { t } = useTranslation();
    const { formatMillions } = useNumberFormatter();
    const portfolioName = usePortfolioName();
    const { labels } = useContext(TagFilterContext);
    const title = 'LON'
    const mp = useLoanMappedData(data, gradientColors);
    if (!data || !mp) return null;

    const approvedData = [
        {
            title: `${mp.approved.aprprovedProjectCount} ${t('one_pager_report.number_approved_projects')}`,
            data: formatMillions(mp.approved.aprprovedProjectAmount),
            units: "MM"
        },
        {
            title: `${mp.approved.preparationProjectCount} ${t('one_pager_report.projects_in_preparation')} (Pipeline A)`,
            data: formatMillions(mp.approved.preparationProjectAmount),
            units: "MM"
        }
    ]

    return (
        <>
            <div className='c-main'>
                <div style={{ margin: '0rem 1.5rem' }}>
                    <HeaderExtended
                        portfolioName={portfolioName}
                        filtersApplied={filtersApplied ?? labels}
                        creationDate={creationDate}
                        regions={regions}
                        countries={countries}
                        myPortfolio={myPortfolio}
                    />
                </div>

                <div className='content'>
                    <div className='section content-background'>
                        <header className="header-content mb-2">
                            <p>{t('one_pager_report.lon_title')}</p>
                            <ReusableIcon
                                title={title}
                                color="#BE86D8"
                            />
                        </header>

                        <div className="c-charts-loan">

                            <CompositionLonCard
                                t={t}
                                mp={mp}
                            />

                            <AmountsApprovedCard
                                t={t}
                                formatMillions={formatMillions}
                                mp={mp}
                            />

                            <TitlesAndValuesCard
                                principalTitle={t('one_pager_report.approved_proyects')}
                                generalData={approvedData}
                                styleContent="approve-projects"
                            />

                            <PendingCard
                                firstData={data.pendingLegalValidity}
                                firstTitle={t('one_pager_report.pending_legal_validity')}
                            />

                            <ExpiredDisbursementsCard quantity={data.projectsOverdueDisbursement} />

                            <WalletCompositionCard
                                t={t}
                                mp={mp}
                            />

                            <ProjectionsYearLon
                                t={t}
                                data={data}
                                mp={mp}
                            />

                            <PmrLonCard
                                mp={mp}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ExtendedReportLoan